import { useMemo } from 'react';

import type { Station } from '../types/station';
import { getDistanceInKm } from '../utils/distance';
import type { Coordinates } from '../utils/geolocation';

// A station paired with how far it is from the reference point, so the list can
// show the distance next to each row.
export type StationWithDistance = Station & {
  distanceInKm: number;
};

/**
 * Orders the given stations by their distance to `center`, closest first. Used
 * by the station list so the stations nearest to the map center appear on top;
 * calling it again with a new `center` (e.g. the freshly read user location)
 * re-sorts the list.
 */
export const useStationsByDistance = (
  stations: Station[],
  center: Coordinates,
): StationWithDistance[] =>
  useMemo(
    () =>
      stations
        .map(station => ({
          ...station,
          distanceInKm: getDistanceInKm(center, {
            latitude: station.latitude,
            longitude: station.longitude,
          }),
        }))
        .sort((first, second) => first.distanceInKm - second.distanceInKm),
    [stations, center],
  );
